const config = {}
const PUBLIC = '/api/'
if (window.CONSTANT && window.CONSTANT.isReverse || process.env.NODE_ENV === 'development') {
  config.api = PUBLIC
} else {
  config.api = window.CONSTANT && window.CONSTANT.api.base || PUBLIC
}
module.exports = config



// WEBPACK FOOTER //
// ./src/api/config-client.js